import { gql } from "@apollo/client";

export const createOrganization = gql`
    mutation createOrganization($orgName: String) {
        createOrganization(input: { orgName: $orgName }) {
            organization {
                name
                id
                role
            }
        }
    }
`;
